import high from "./severity_high.svg";
import medium from "./severity_medium.svg";
import low from "./severity_low.svg";

export const severityIcons = {
  high,
  medium,
  low,
};
